export const authors = [
  {
    slug: "kunal-prakash-jha",
    name: "Kunal Prakash Jha",
    tier: "House Author",
    photoInitials: "KJ",
    accent: "#721817",
    tagline: "Political biographer. Election analyst. Diaspora chronicler.",
    shortBio: "Kunal Prakash Jha is a political biographer and election analyst whose work has helped define contemporary Indian political non-fiction.",
    fullBio: `Kunal Prakash Jha is among India's most prolific political biographers of his generation. Trained in political science and public policy, he has spent a decade travelling across the Hindi belt, the Northeast, Punjab, and the Gulf — reconstructing careers, constituencies, and cultural undercurrents through a combination of archival research, longform interviewing, and constituency-level data.

His work sits at the intersection of political biography, election analysis, and diaspora reportage. He has authored four titles for Conlang Book House across three imprints, including the flagship Bharat Icon Series.`,
    credentials: [
      "Author of CBH titles across politics, elections, and diaspora enterprise",
      "Extensive field reporting across India, UAE, and the UK",
      "Regular contributor to national policy dialogues",
    ],
    availableFor: ["Speaking engagements", "Podcast interviews", "Policy briefings"],
  },
  {
    slug: "sanjeev-chaudhary",
    name: "Sanjeev Chaudhary",
    tier: "House Author",
    photoInitials: "SC",
    accent: "#0F1533",
    tagline: "Political affairs writer and long-form investigator.",
    shortBio: "Sanjeev Chaudhary is a political affairs writer who has co-authored two flagship CBH biographies with Kunal Prakash Jha.",
    fullBio: `Sanjeev Chaudhary began his career as a political correspondent covering the northern states and moved to long-form investigative writing in the last decade. He specialises in reconstructing careers of political leaders through primary sources, government records, and party archival material.

At CBH, he co-authors the Bharat Icon Series flagship biographies, blending reportage with narrative history to produce volumes that hold up across both academic and general readerships.`,
    credentials: [
      "20+ years in political reportage",
      "Contributor across the Bharat Icon Series and House List",
    ],
    availableFor: ["Speaking engagements", "Editorial consultations"],
  },
  {
    slug: "shravan-kumar-irs",
    name: "Dr. Shravan Kumar (IRS)",
    tier: "Conlang Fellow",
    photoInitials: "SK",
    accent: "#1F6478",
    tagline: "Civil servant. Cinema historian. Cultural policy thinker.",
    shortBio: "Dr. Shravan Kumar is an Indian Revenue Service officer whose scholarship on cinema and cultural governance has earned him the CBH Fellows tier.",
    fullBio: `Dr. Shravan Kumar has served two decades in the Indian Revenue Service while quietly building one of the most singular voices in Indian cultural policy writing. His work asks how a country makes — and does not make — culture for its children, and how the state's imagination shapes what a young republic becomes.

The Republic of Children is his first full-length work with CBH and inaugurates the Conlang Fellows programme.`,
    credentials: [
      "Officer, Indian Revenue Service",
      "Fellow, Conlang International",
      "Two decades of cultural policy scholarship",
    ],
    availableFor: ["Lectures", "Policy panels", "Academic collaborations"],
  },
  {
    slug: "rashmi-sharma",
    name: "Rashmi Sharma",
    tier: "House Author",
    photoInitials: "RS",
    accent: "#1F5A3A",
    tagline: "Democracy writer. Gender and representation researcher.",
    shortBio: "Rashmi Sharma is a democracy writer focused on gender, representation, and the deep architecture of Indian political institutions.",
    fullBio: `Rashmi Sharma writes at the intersection of democracy, gender, and institutional design. Her work centres the question of what representation actually delivers — beyond symbolism — for the half of the Indian population that has historically been under-represented in its legislatures.

The Half of the Nation Speaks is her CBH debut and marks the launch of the Contemporary Democracy series.`,
    credentials: [
      "Contributor to leading Indian policy journals",
      "Field research across five Indian states",
      "Recognised voice on the Women's Reservation Bill",
    ],
    availableFor: ["Speaking engagements", "Media appearances", "Policy briefings"],
  },
  {
    slug: "cbh-editorial-board",
    name: "The CBH Editorial Board",
    tier: "House Imprint",
    photoInitials: "CBH",
    accent: "#721817",
    tagline: "Anonymous authorship, collective scholarship.",
    shortBio: "For select Bharat Icon Series and Wisdom Series volumes, CBH publishes under a collective editorial byline.",
    fullBio: `Some subjects — Gandhi, Kalam, ancient Bharatiya wisdom — sit above any single authorial voice. For these, CBH publishes under the collective editorial byline of the House. Each such volume is produced by a rotating team of historians, editors, researchers, and specialists supervised by the CBH Editorial Board.

Every claim is sourced, every interpretation reviewed, every volume approved for publication only by unanimous board vote.`,
    credentials: [
      "The publishing standard of Conlang Book House",
      "Anonymous editorial custodianship",
      "Supervised by the CBH Editorial Board",
    ],
    availableFor: ["Editorial partnerships", "Library and institutional programmes"],
  },
];

export const getAuthorBySlug = (slug) => authors.find((a) => a.slug === slug);
